import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import API from "api";

// Add Event
export const addEvent = createAsyncThunk(
    "event/addEvent",
    async (formData, { rejectWithValue }) => {
        try {
            const response = await API.post("/events/addEvent", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            return response.data;
        } catch (error) {
            console.error("Error adding event:", error.response?.data || error.message);
            return rejectWithValue(error.response?.data?.message || "Failed to add Event");
        }
    }
);


// Delete Event
export const deleteEvent = createAsyncThunk(
    "event/deleteEvent",
    async (id, { rejectWithValue }) => {
        try {
            await API.delete(`/events/deleteEvent/${id}`);
            return id;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to delete Event");
        }
    }
);

// Update Event
export const updateEvent = createAsyncThunk(
    "event/updateEvent",
    async ({ id, updatedData }, { rejectWithValue }) => {
        try {
            const response = await API.put(`/events/updateEvent/${id}`, updatedData);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to update Event");
        }
    }
);


// Fetch Events
export const fetchEvents = createAsyncThunk(
    "event/fetchEvents",
    async (_, { rejectWithValue }) => {
        try {
            const response = await API.get("/events/getEvent");
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to fetch Events");
        }
    }
);

const eventSlice = createSlice({
    name: "event",
    initialState: {
        events: [],
        status: "idle",
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Add Event
            .addCase(addEvent.pending, (state) => {
                state.status = "loading";
            })
            .addCase(addEvent.fulfilled, (state, action) => {
                state.status = "succeeded";
                if (!state.events.some(event => event._id === action.payload.event._id)) {
                    state.events.push(action.payload.event);
                }
            })
            .addCase(addEvent.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload?.message || "Unknown error occurred";
            })

            // Delete Event
            .addCase(deleteEvent.pending, (state) => {
                state.status = "loading";
            })
            .addCase(deleteEvent.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.events = state.events.filter((event) => event.id !== action.payload);
            })
            .addCase(deleteEvent.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
            })
            // Update Event
            .addCase(updateEvent.pending, (state) => {
                state.status = "loading";
            })
            .addCase(updateEvent.fulfilled, (state, action) => {
                state.status = "succeeded";
                const index = state.events.findIndex((event) => event.id === action.payload.id);
                if (index !== -1) {
                    state.events[index] = action.payload;
                }
            })
            .addCase(updateEvent.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
            })
            // Fetch Events
            .addCase(fetchEvents.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchEvents.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.events = action.payload;
            })
            .addCase(fetchEvents.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
            });
    },
});

export default eventSlice.reducer;
